/**
 * @flow
 * @relayHash 288f89d5470ee0c092084cd86ab5b43a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type PerformanceType = "CA_SELL_TRANSACTION" | "CONTRACT_CHANGE" | "DUMMY_NOOP" | "SAME_CONTRACT_SPLIT" | "SHARE_PURCHASE_PLAN" | "%future added value";
export type BrokerActivityPerformanceFormQueryVariables = {|
  brokerActivityGroupId: string
|};
export type BrokerActivityPerformanceFormQueryResponse = {|
  +viewer: ?{|
    +performanceTypeEnum: ?{|
      +enumValues: ?$ReadOnlyArray<{|
        +description: ?string,
        +name: string,
      |}>
    |},
    +brokerActivityGroups: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +possiblePerformanceTypes: ?$ReadOnlyArray<?PerformanceType>,
          +brokeractivitySet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +ibcorporateaction: ?{|
                  +amount: number,
                  +symbol: string,
                  +proceeds: number,
                  +quantity: number,
                  +currency: ?Currency,
                |},
                +brokeractivitytransactionSet: {|
                  +count: ?number,
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +id: string,
                      +account: {|
                        +id: string,
                        +name: ?string,
                      |},
                      +brokeractivitytransactionperformanceSet: {|
                        +edges: $ReadOnlyArray<?{|
                          +node: ?{|
                            +id: string,
                            +sequence: number,
                            +portfolio: {|
                              +id: string,
                              +trackingVueName: ?string,
                            |},
                            +contract: {|
                              +id: string,
                              +symbol: string,
                            |},
                            +costBasis: ?number,
                            +commission: number,
                            +updatedAt: any,
                            +currency: Currency,
                            +price: number,
                            +quantity: number,
                            +splitFactor: ?number,
                            +splitResult: ?number,
                            +oldContract: ?{|
                              +id: string,
                              +symbol: string,
                            |},
                            +newContract: ?{|
                              +id: string,
                              +symbol: string,
                            |},
                            +spinoffContract: ?{|
                              +id: string,
                              +symbol: string,
                            |},
                            +dummied: boolean,
                          |}
                        |}>
                      |},
                      +brokeractivitytransactioncashdeltaSet: {|
                        +edges: $ReadOnlyArray<?{|
                          +node: ?{|
                            +id: string,
                            +quantity: number,
                            +currency: Currency,
                            +portfolio: ?{|
                              +id: string
                            |},
                          |}
                        |}>
                      |},
                      +brokeractivitytransactioncontractdeltaSet: {|
                        +edges: $ReadOnlyArray<?{|
                          +node: ?{|
                            +id: string,
                            +quantity: number,
                            +portfolio: {|
                              +id: string,
                              +trackingVueName: ?string,
                            |},
                            +contract: {|
                              +id: string,
                              +symbol: string,
                              +currency: Currency,
                            |},
                          |}
                        |}>
                      |},
                    |}
                  |}>,
                |},
              |}
            |}>
          |},
        |}
      |}>
    |},
  |}
|};
export type BrokerActivityPerformanceFormQuery = {|
  variables: BrokerActivityPerformanceFormQueryVariables,
  response: BrokerActivityPerformanceFormQueryResponse,
|};
*/


/*
query BrokerActivityPerformanceFormQuery(
  $brokerActivityGroupId: ID!
) {
  viewer {
    performanceTypeEnum: __type(name: "PerformanceType") {
      enumValues {
        description
        name
      }
    }
    brokerActivityGroups(id: $brokerActivityGroupId) {
      edges {
        node {
          possiblePerformanceTypes
          brokeractivitySet {
            edges {
              node {
                id
                ibcorporateaction {
                  amount
                  symbol
                  proceeds
                  quantity
                  currency
                  id
                }
                brokeractivitytransactionSet {
                  count
                  edges {
                    node {
                      id
                      account {
                        id
                        name
                      }
                      brokeractivitytransactionperformanceSet {
                        edges {
                          node {
                            id
                            sequence
                            portfolio {
                              id
                              trackingVueName
                            }
                            contract {
                              id
                              symbol
                            }
                            costBasis
                            commission
                            updatedAt
                            currency
                            price
                            quantity
                            splitFactor
                            splitResult
                            oldContract {
                              id
                              symbol
                            }
                            newContract {
                              id
                              symbol
                            }
                            spinoffContract {
                              id
                              symbol
                            }
                            dummied
                          }
                        }
                      }
                      brokeractivitytransactioncashdeltaSet {
                        edges {
                          node {
                            id
                            quantity
                            currency
                            portfolio {
                              id
                            }
                          }
                        }
                      }
                      brokeractivitytransactioncontractdeltaSet {
                        edges {
                          node {
                            id
                            quantity
                            portfolio {
                              id
                              trackingVueName
                            }
                            contract {
                              id
                              symbol
                              currency
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          id
        }
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "brokerActivityGroupId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": "performanceTypeEnum",
  "name": "__type",
  "storageKey": "__type(name:\"PerformanceType\")",
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "PerformanceType"
    }
  ],
  "concreteType": "__Type",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        (v1/*: any*/)
      ]
    }
  ]
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "brokerActivityGroupId"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "possiblePerformanceTypes",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "proceeds",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolio",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioNode",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "trackingVueName",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = [
  (v5/*: any*/),
  (v7/*: any*/)
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactionSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "count",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionNode",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "account",
              "storageKey": null,
              "args": null,
              "concreteType": "AccountNode",
              "plural": false,
              "selections": [
                (v5/*: any*/),
                (v1/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "brokeractivitytransactionperformanceSet",
              "storageKey": null,
              "args": null,
              "concreteType": "BrokerActivityTransactionPerformanceNodeConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "BrokerActivityTransactionPerformanceNodeEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "BrokerActivityTransactionPerformanceNode",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "sequence",
                          "args": null,
                          "storageKey": null
                        },
                        (v11/*: any*/),
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "contract",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractNode",
                          "plural": false,
                          "selections": (v12/*: any*/)
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "costBasis",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "commission",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "updatedAt",
                          "args": null,
                          "storageKey": null
                        },
                        (v10/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "price",
                          "args": null,
                          "storageKey": null
                        },
                        (v9/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "splitFactor",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "splitResult",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "oldContract",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractNode",
                          "plural": false,
                          "selections": (v12/*: any*/)
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "newContract",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractNode",
                          "plural": false,
                          "selections": (v12/*: any*/)
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "spinoffContract",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractNode",
                          "plural": false,
                          "selections": (v12/*: any*/)
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "dummied",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "brokeractivitytransactioncashdeltaSet",
              "storageKey": null,
              "args": null,
              "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "BrokerActivityTransactionCashDeltaNode",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/),
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "portfolio",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "PortfolioNode",
                          "plural": false,
                          "selections": [
                            (v5/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "brokeractivitytransactioncontractdeltaSet",
              "storageKey": null,
              "args": null,
              "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "BrokerActivityTransactionContractDeltaNode",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        (v9/*: any*/),
                        (v11/*: any*/),
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "contract",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractNode",
                          "plural": false,
                          "selections": [
                            (v5/*: any*/),
                            (v7/*: any*/),
                            (v10/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BrokerActivityPerformanceFormQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokerActivityGroups",
            "storageKey": null,
            "args": (v3/*: any*/),
            "concreteType": "BrokerActivityGroupNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BrokerActivityGroupNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityGroupNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivitySet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityNode",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "ibcorporateaction",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "IBCorporateActionNode",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BrokerActivityPerformanceFormQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokerActivityGroups",
            "storageKey": null,
            "args": (v3/*: any*/),
            "concreteType": "BrokerActivityGroupNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BrokerActivityGroupNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityGroupNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivitySet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityNode",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "ibcorporateaction",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "IBCorporateActionNode",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "BrokerActivityPerformanceFormQuery",
    "id": null,
    "text": "query BrokerActivityPerformanceFormQuery(\n  $brokerActivityGroupId: ID!\n) {\n  viewer {\n    performanceTypeEnum: __type(name: \"PerformanceType\") {\n      enumValues {\n        description\n        name\n      }\n    }\n    brokerActivityGroups(id: $brokerActivityGroupId) {\n      edges {\n        node {\n          possiblePerformanceTypes\n          brokeractivitySet {\n            edges {\n              node {\n                id\n                ibcorporateaction {\n                  amount\n                  symbol\n                  proceeds\n                  quantity\n                  currency\n                  id\n                }\n                brokeractivitytransactionSet {\n                  count\n                  edges {\n                    node {\n                      id\n                      account {\n                        id\n                        name\n                      }\n                      brokeractivitytransactionperformanceSet {\n                        edges {\n                          node {\n                            id\n                            sequence\n                            portfolio {\n                              id\n                              trackingVueName\n                            }\n                            contract {\n                              id\n                              symbol\n                            }\n                            costBasis\n                            commission\n                            updatedAt\n                            currency\n                            price\n                            quantity\n                            splitFactor\n                            splitResult\n                            oldContract {\n                              id\n                              symbol\n                            }\n                            newContract {\n                              id\n                              symbol\n                            }\n                            spinoffContract {\n                              id\n                              symbol\n                            }\n                            dummied\n                          }\n                        }\n                      }\n                      brokeractivitytransactioncashdeltaSet {\n                        edges {\n                          node {\n                            id\n                            quantity\n                            currency\n                            portfolio {\n                              id\n                            }\n                          }\n                        }\n                      }\n                      brokeractivitytransactioncontractdeltaSet {\n                        edges {\n                          node {\n                            id\n                            quantity\n                            portfolio {\n                              id\n                              trackingVueName\n                            }\n                            contract {\n                              id\n                              symbol\n                              currency\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c85490ae63aa8d0bea2834b759ae4573';
module.exports = node;
